"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var use_stores_1 = require("hooks/use-stores");
var use_notification_1 = require("hooks/use-notification");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var TextInput_1 = __importDefault(require("components/common/inputs/TextInput"));
var FileInput_1 = __importDefault(require("components/common/inputs/FileInput"));
var Notification_1 = require("components/Notification");
var Button_1 = __importDefault(require("components/common/buttons/Button"));
var Loading_1 = __importDefault(require("components//Loading"));
var utils_1 = require("../../../util/utils");
var done_icon_dark_svg_1 = __importDefault(require("res/img/done-icon-dark.svg"));
var EditClient = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState(null), fileList = _b[0], setFileList = _b[1];
    var _c = react_1.useState(false), success = _c[0], setSuccess = _c[1];
    var _d = use_stores_1.useStores(), clientStore = _d.clientStore, apiStore = _d.apiStore;
    var history = react_router_dom_1.useHistory();
    var params = react_router_dom_1.useParams();
    var notification = use_notification_1.useNotification();
    var busy = apiStore.data.busyRoutes.includes('/clients');
    var redirectTimerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        for (var _i = 0, _a = clientStore.data; _i < _a.length; _i++) {
            var client = _a[_i];
            if (client.id === parseInt(params.id)) {
                setData(client);
                break;
            }
        }
    }, [params.id, clientStore.data.length]);
    var changeHandler = function (e) {
        var _a;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var fileChangeHandler = function (name, files) {
        var file = files[0];
        var error = null;
        if (files.length > 1)
            error = 'Please upload only 1 file';
        if (!file.type.match(/^(image\/png|image\/svg|image\/svg\+xml)$/))
            error = 'Please upload only a PNG or SVG file';
        if (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        setFileList(files);
    };
    var fileErrorHandler = function (error) {
        notification({
            variant: Notification_1.NotificationVariants.ERROR,
            message: error
        });
        setFileList(null);
    };
    var submitHandler = function () {
        var error = null;
        if (!data.clientName || data.clientName.length <= 0)
            error = 'Please enter a name';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        var formData = utils_1.toFormData(data);
        if (fileList && fileList.length > 0) {
            formData.append('clientImage', fileList[0]);
        }
        formData.append('_method', 'PATCH');
        api_1.default.editClient(data.id, formData)
            .then(function (response) {
            setSuccess(true);
            clientStore.editDataItem(response.data);
            redirectTimerRef.current = setTimeout(function () {
                history.replace('/clients');
            }, 2000);
        }).catch(api_1.catchHandler);
    };
    return (react_1.default.createElement(Modal_1.default, { title: 'Edit  Client' },
        react_1.default.createElement("div", { className: 'add-client form' },
            react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'clientName', placeholder: 'Client Name', autoFocus: true, value: data.clientName || '', onChange: changeHandler }),
            react_1.default.createElement(TextInput_1.default, { type: 'text', name: 'websiteUrl', placeholder: 'Website URL', value: data.websiteUrl || '', onChange: changeHandler }),
            react_1.default.createElement(FileInput_1.default, { name: 'clientImage', label: 'Change Image', files: fileList, onFileError: fileErrorHandler, onFileSelect: fileChangeHandler, accept: 'image/png, image/svg, image/svg+xml' }),
            react_1.default.createElement(Button_1.default, { icon: busy ? react_1.default.createElement(Loading_1.default, null) : success ? react_1.default.createElement("img", { src: done_icon_dark_svg_1.default, alt: 'Done' }) : null, onClick: submitHandler }, "Save Client"))));
});
exports.default = EditClient;
